import { CssBaseline } from '@mui/material';
import '@fontsource/fira-sans';
import '@fontsource/fira-sans/500.css';
import '@fontsource/fira-sans/600.css';
import '@fontsource/fira-sans/700.css';
import '@fontsource/fira-sans/800.css';
import '@fontsource/fira-sans-condensed';
import '@fontsource/fira-code';

export default () => <CssBaseline />;
